import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Toastr } from 'src/app/core-module/models/Utils/toastr';

@Component({
    selector: 'app-toastr',
    templateUrl: './toastr.component.html',
    styleUrl: './toastr.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ToastrComponent {
  @Input() toastr:Toastr = new Toastr;
}
